// Page geometry for white-label report pages.
//
// PDF pagination in this app is pure geometry, not page-break CSS: GeneratePDF
// rasterizes #content through jsPDF's doc.html() at html2canvas scale 0.75, so
// each 794 x 1122.7px Layout maps to 595.5 x 842.03pt ~= A4 (595.28 x 841.89pt).
// The ~0.14pt overflow per page is what makes GeneratePDF's blind
// deletePage(pageCount) safe — the trailing spill page is always blank. Do not
// "correct" PAGE_H to remove it.

export const PAGE_W = 794;
export const PAGE_H = 1122.7;

// Layout's 1px bottom border sits inside its border-box, so the paintable box is
// 1px shorter than the page pitch.
export const PAINTABLE_H = PAGE_H - 1;

export const HEADER_H = 55;
export const FOOTER_H = 35;

// 1.7px is deliberately left unallocated (55 + 1030 + 35 = 1120 < 1121.7) so
// sub-pixel rounding can never push content past Layout's overflow: hidden.
export const CONTENT_H = 1030;

export const GUTTER = 28;
export const CONTENT_W = PAGE_W - GUTTER * 2;
